import { app } from '../../../../../app';
import { domainsFromDto } from './directory.functions';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.directory-groups.directory', {
        url: '/directory/:directoryId',
        params: {directoryId: 'saaspass-cloud-directory'},
        componentProvider,
        resolve: {
            $breadcrumbs,
            connectionDetails,
            directory,
            directoryId,
            domains,
            groups,
        },
    });
}

/** @ngInject */
function componentProvider(directoryId) {
    if (directoryId === 'saaspass-cloud-directory') {
        return 'companyUserDirectoriesDirectoryGroupsSaaspassCloudDirectory';
    } else {
        return 'companyUserDirectoriesDirectoryGroupsDirectory';
    }
}

/** @ngInject */
function $breadcrumbs(directory) {
    return [{title: directory.name}];
}

/** @ngInject */
function connectionDetails(companyId, DirectoriesResource, directoryId) {
    if (directoryId !== 'saaspass-cloud-directory') {
        return DirectoriesResource.getDirectoryConnectionDetails(companyId, directoryId);
    }
}

/** @ngInject */
function directory(directories, directoryId) {
    return directories.find(({id}) => id === directoryId);
}

/** @ngInject */
function directoryId($stateParams) {
    return $stateParams.directoryId;
}

/** @ngInject */
function domains($filter, companyId, DirectoriesResource, directoryId) {
    if (directoryId !== 'saaspass-cloud-directory') {
        return DirectoriesResource
            .getDirectoryGroups(companyId, directoryId)
            .then((domains) => $filter('orderBy')(domains, 'isRoot', true))
            .then(domainsFromDto)
    }
}

/** @ngInject */
function groups(companyId, DirectoriesResource, directoryId) {
    if (directoryId === 'saaspass-cloud-directory') {
        return DirectoriesResource.getSaaspassCloudDirectoryGroups(companyId);
    } else {
        return [];
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/directory-groups/directory/directory.state.js